import React, { useContext, useEffect } from "react";
import { useFlywireCallback } from "./hooks/useFlywireCallback";
import { PaymentResult } from "../../../../../PaymentResult/PaymentResult";
import { useAppConfiguration } from "../../../../../../../../../../utils/hooks/useAppConfiguration";
import { ProcessContext } from "../../../../../../../../../../contexts/ProcessContext";
import { AuthContext } from "../../../../../../../../../../contexts/AuthContext";
import { Box, CircularProgress } from "@material-ui/core";

export const FlywireCallback = ({ paymentPlanLineId }) => {
  const {
    state: { paymentPlan },
  } = useContext(ProcessContext);
  const {
    state: { agent },
  } = useContext(AuthContext);

  const { result } = useFlywireCallback(paymentPlanLineId);
  const { requestGetLoanAndAgent } = useAppConfiguration();

  useEffect(() => {
    if (!paymentPlan || agent) return;
    requestGetLoanAndAgent(paymentPlan.external_id);
  }, [paymentPlan]);

  return !result ? (
    <Box
      display={"flex"}
      flexGrow={1}
      justifyContent={"center"}
      alignItems={"center"}
      width={"100%"}
      height={"100%"}
    >
      <CircularProgress color="secondary" size={100} thickness={1} />
    </Box>
  ) : (
    <PaymentResult paymentPlanLineId={paymentPlanLineId} result={result} />
  );
};
